import { useMemo } from 'react'

import { useQuery } from '@api/hooks'
import { MarketBasketStatus } from '@domain'
import { Autocomplete, TextField } from '@mui/material'
import MarketBasketsApi, { MarketBasketsKeys } from '@services/marketBaskets.api'
import { useMarketBasketContext } from '@views/MarketBaskets/MarketBaskets.hooks'
import { useParams } from 'react-router-dom'
import { UrlUpdateType } from 'use-query-params'

type Props = {
	value: number | null
	updateFilters: (changes: any, updateTypeOverride?: UrlUpdateType) => void
}

export default function Manufacturer({ value, updateFilters }: Props) {
	const { marketBasketId } = useParams()
	const { marketBasket } = useMarketBasketContext()

	const isRecalculating = marketBasket?.status === MarketBasketStatus.RECALCULATING

	const { data, isLoading } = useQuery({
		queryKey: MarketBasketsKeys.manufacturers(marketBasketId),
		queryFn: () => MarketBasketsApi.manufacturers(marketBasketId),
		enabled: !isRecalculating,
	})

	const selectedValues = useMemo(() => {
		if (isLoading || isRecalculating) return []
		const selected = data.filter((v) => v.id === value)
		return selected.length > 0 ? selected[0] : null
	}, [data, isLoading, value, isRecalculating])

	const handleChange = (e, value) => {
		if (value) {
			updateFilters({ manufacturer: value.id })
		} else {
			updateFilters({ manufacturer: '' })
		}
	}

	return (
		<Autocomplete
			disabled={isLoading || isRecalculating}
			fullWidth
			size="small"
			options={data || []}
			value={isLoading ? null : selectedValues}
			getOptionLabel={(option) => {
				if (option.length === 0) return ''
				return option.label || ''
			}}
			onChange={handleChange}
			renderInput={(params) => <TextField {...params} label="Manufacturer" />}
			slotProps={{ paper: { style: { width: '24rem' } } }}
		/>
	)
}
